import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import config from "./config";
import AuthProvider from "./AuthProvider";
import PermissionsProvider from "./authz/PermissionsProvider";
import {ActiveRoleProvider} from "./utils/activeRole";
import { SupportViewAsProvider } from "./supportViewAs/SupportViewAsProvider";
import { FeatureFlagsProvider } from "./features/featureFlags";

const root = ReactDOM.createRoot(document.getElementById("root"));

const Tree = (
  <AuthProvider>
    <FeatureFlagsProvider>
      <SupportViewAsProvider>
        <PermissionsProvider>
          <ActiveRoleProvider>
            <App />
          </ActiveRoleProvider>
        </PermissionsProvider>
      </SupportViewAsProvider>
    </FeatureFlagsProvider>
  </AuthProvider>
);

if (config.enableStrictMode) {
  root.render(<React.StrictMode>{Tree}</React.StrictMode>);
} else {
  root.render(Tree);
}
